// ReusableGitInfoPage.js
import React, { useState, useEffect } from 'react';
import Banner from '../Banner';
import B2BFormContainer from '../B2BFormContainer';
import JSONPretty from 'react-json-pretty';
import 'react-json-pretty/themes/monikai.css';

import './ReusableGitInfoPage.css';

const ReusableGitInfoPage = ({ bannerMessage, fetchMethod, fetchMethodParams = null, showBanner = true }) => {
    const [gitInfoData, setGitInfoData] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const data = await fetchMethod(fetchMethodParams);
                setGitInfoData(data);
            } catch (error) {
                setError(error.message);
            }
        };
        fetchData();
    }, [fetchMethod, fetchMethodParams]);

    return (
        <>
            {showBanner && (<Banner message={bannerMessage} />)}
            {error && <p>Error: {error}</p>}
            {
                gitInfoData && (
                    <B2BFormContainer title='Git commit form' className="git-commit-form">
                        <JSONPretty id="json-pretty" data={gitInfoData}></JSONPretty>
                    </B2BFormContainer>
                )
            }
        </>
    );
};

export default ReusableGitInfoPage;